import React, { type ReactNode } from 'react';
import ExternalLinkIcon from '../../../assets/ExternalLinkIcon.svg';
import styled from 'styled-components';

export type ExternalLinkButtonProps = {
  href: string;
  text: ReactNode;
  className?: string;
  hideIcon?: boolean;
};

const ExternalLinkButton: React.FC<ExternalLinkButtonProps> = ({ href, text, className, hideIcon }) => {
  return (
    <StyledLinkButton href={href} className={className} target="_blank">
      <Content>
        <Text>{text}</Text>
        {!hideIcon && <ExternalLinkIcon />}
      </Content>
    </StyledLinkButton>
  );
};

export default ExternalLinkButton;

const StyledLinkButton = styled.a`
  font-size: ${({ theme }) => theme.fontSizes.medium};
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 4px;
`;

const Text = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  white-space: nowrap;
  text-decoration: underline;
`;
